export var DocumentCompletionStatus;
(function (DocumentCompletionStatus) {
    DocumentCompletionStatus["CreatedNotStarted"] = "createdNotStarted";
    DocumentCompletionStatus["InProgress"] = "inProgress";
    DocumentCompletionStatus["Completed"] = "completed";
})(DocumentCompletionStatus || (DocumentCompletionStatus = {}));
//# sourceMappingURL=index.js.map